module.exports = __webpack_public_path__ + "static/media/emine-tarin-header-logo.69fb8f1f.png";